<template>
    <div class="textbox">
        
        <InputText placeholder="" 
         :class="{'p-invalid': isError,'redFont':isRedFont}"
         @keydown.enter.prevent 
          v-model="value" 
          :disabled="disabled"
          :required="required"
          :readonly="readonly"
           />
    </div>
</template>  
<script>

export default {
    props: ["modelValue",'required', 'disabled', 'readonly', 'label', 'isEmail','isRedFont'],
    emits: ["update:modelValue"],
    components: {

    },
    data() {
        return {
            value :'',
            valueError:false,
           
        }
    },
    Service: null,
    EFormService: null,
    created() {
        this.value = this.modelValue

   
    },
    watch: {
            modelValue: function () {
               this.value = this.modelValue
            },
            value: function (newVal) {
              this.$emit("update:modelValue", newVal );
            },
          },
    computed: {
        isError() {
             let b= false;
             let a=  this.required &&  !this.value ;
             if(this.value && this.isEmail){
                 b=  !this.ValidateEmail(this.value);
             }
             return a || b;
        },
    },
 methods: {
              
        validateEmail() {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) // eslint-disable-line
            {
                this.msg['email'] = 'Please enter a valid email address';
            } else {
                this.msg['email'] = '';
            }
        },
        ValidateEmail(email) {
            if(email)
            {
                //console.log('ValidateEmail')
                //var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                var validRegex =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;// eslint-disable-line
                //var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;// eslint-disable-line
                if (email.match(validRegex)) {
                    return true;

                } else {
                    return false;
                }
            }
            return false;
            

        }
    }
}
</script>
<style scoped>
.redFont{

    color:red;

}

.textbox {
    text-align: left;
    padding: 0.5rem 0.5rem;
  }
   
   
  
  .textbox input {
    min-height: 40px;
    width: 100%;
 
  }
</style>


  
  